var map = {
	"./audio-1.jpg": "b8e8",
	"./audio-2.jpg": "7f41",
	"./audio-3.jpg": "1dbc",
	"./audio-4.jpg": "fc97",
	"./design-1.jpg": "3fa0",
	"./home.jpg": "efd7",
	"./image-1.jpg": "08a7",
	"./motion-1.jpg": "06e4",
	"./poster.jpg": "bb1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f68c";